import React, { Component } from "react";
import "./resources/stylesheets/main.css";
import { Router, Switch, Route } from "react-router-dom";
import { Provider } from "react-redux";
import history from "./history";
import LoginView from "./layouts/LoginView";
import RegisterView from "./layouts/RegisterView";
import MainContainerLayout from "./layouts/MainContainerLayout";
import store from "./store/Store";
import { MetaData } from "./components/MetaData";

class App extends Component {
  render() {
    const APP_ROUTES = [
      {
        path: "/",
        exact: true,
        component: (props) => (
          <Provider store={store}>
            <LoginView {...props} />
          </Provider>
        ),
      },
      {
        path: "/home",
        exact: false,
        component: (props) => (
          <Provider store={store}>
            <MainContainerLayout {...props} />
          </Provider>
        ),
      },
      {
        path: "/register",
        exact: true,
        component: (props) => (
          <Provider store={store}>
            <RegisterView {...props} />
          </Provider>
        ),
      },
    ];

    return (
      <MetaData>
        <Router history={history} basename="/">
          <Switch>
            {APP_ROUTES.map((route, index) => (
              <Route key={index} {...route} />
            ))}
          </Switch>
        </Router>
      </MetaData>
    );
  }
}

export default App;
